import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "app-market-mapping-table",
  templateUrl: "./market-mapping-table.component.html",
  styleUrls: ["./market-mapping-table.component.scss"],
})
export class MarketMappingTableComponent implements OnInit {
  bfsportId = "";
  srsportId = "";
  bfeventId = "";
  sreventId = "";
  startDate: null;
  endDate: null;
  
  mappedEventsTableHeaders: string[] = ["marketId", "marketName"];
  bfMarkets = [];
  srMarkets = [];
  marketNames = ["winner", "1x2"];
  marketIds = {
    betFair: "",
    sportRadar: "",
  };
  selectedBFMarket = [];
  selectedSRMarket = [];
  isValidMarketPair = false;
  expectedSRMarketBySportId: { [key: string]: string } = {
    "4": "340", // Cricket
    "1": "1", // Soccer
    "2": "186", // Tennis
  };
  sportNameById: { [key: string]: string } = {
    "4": "Cricket",
    "1": "Soccer",
    "2": "Tennis",
  };
  constructor(
    private appService: AppService,
    private router: ActivatedRoute,
    private route: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.router.queryParams.subscribe((params) => {
      this.bfsportId = params["bfsportId"];
      this.srsportId = params["srsportId"];
      this.bfeventId = params["bfeventId"];
      this.sreventId = params["sreventId"];
      this.startDate  = params["startDate"]
      this.endDate  = params["endDate"]
    });
    this.getMarkets("BetFair", this.bfsportId, this.bfeventId);
    this.getMarkets("SportRadar", this.srsportId, this.sreventId);
  }

  getMarkets(pid, sid, eid) {
    try {
      this.appService.getMarketData(pid, sid, eid).subscribe((res) => {
        if (pid === "BetFair") {
          this.bfMarkets = res.markets;
        } else if (pid === "SportRadar") {
          this.srMarkets = res.markets;
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  back() {
    this.route.navigate(["administration/market-mapping"], {
      queryParams: {
        sportId: this.bfsportId,
        startDate: this.startDate,
        endDate: this.endDate,
      },
    });
  }

  map() {
    this.validateMarketPair(true);
    let dialogRef = this.dialog.open(RunnerMappingModal, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        bfsportId: this.bfsportId,
        srsportId: this.srsportId,
        bfeventId: this.bfeventId,
        sreventId: this.sreventId,
        bfmarketId: this.marketIds.betFair,
        srmarketId: this.marketIds.sportRadar,
        selectedBFMarket: this.selectedBFMarket,
        selectedSRMarket: this.selectedSRMarket,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.back();
      }
    });
  }

  selectMarket(ele) {
    if (ele.ProviderId === "SportRadar") {
      // if (this.marketIds.sportRadar === "") {
      this.marketIds.sportRadar = ele.MarketId;
      this.selectedSRMarket = [ele];
      // } else {
      //   this.marketIds.sportRadar = "";
      //   this.selectedSRMarket = [];
      // }
    } else if (ele.ProviderId === "BetFair") {
      // if (this.marketIds.betFair === "") {
      this.marketIds.betFair = ele.MarketId;
      this.selectedBFMarket = [ele];
      // } else {
      //   this.marketIds.betFair = "";
      //   this.selectedBFMarket = [];
      // }
    }
    this.validateMarketPair(true);
  }

  private getExpectedSRMarketId(): string {
    return this.expectedSRMarketBySportId[String(this.bfsportId || "")] || "";
  }

  private getSelectedBetfairMarketName(): string {
    return String(
      this.selectedBFMarket[0] && this.selectedBFMarket[0].MarketName
        ? this.selectedBFMarket[0].MarketName
        : ""
    )
      .trim()
      .toLowerCase();
  }

  private getSelectedRunnerCount(markets: any[]): number {
    const runners = markets && markets[0] && markets[0].Runners ? markets[0].Runners : [];
    return Array.isArray(runners) ? runners.length : 0;
  }

  validateMarketPair(showError: boolean = false): boolean {
    const hasSelections = this.marketIds.betFair !== "" && this.marketIds.sportRadar !== "";
    if (!hasSelections) {
      this.isValidMarketPair = false;
      return false;
    }

    const bfMarketName = this.getSelectedBetfairMarketName();
    // Only enforce strict market pairing rules for "Match Odds".
    if (bfMarketName === "match odds") {
      const expectedSRMarketId = this.getExpectedSRMarketId();
      const selectedSRMarketId = String(this.marketIds.sportRadar || "");
      if (expectedSRMarketId && selectedSRMarketId !== expectedSRMarketId) {
        this.isValidMarketPair = false;
        if (showError) {
          const sportName =
            this.sportNameById[String(this.bfsportId || "")] || String(this.bfsportId || "");
          this.appService.openErrorBar(
            `For ${sportName}, SportRadar marketId must be ${expectedSRMarketId}.`
          );
        }
        return false;
      }
    }

    const bfRunnerCount = this.getSelectedRunnerCount(this.selectedBFMarket);
    const srRunnerCount = this.getSelectedRunnerCount(this.selectedSRMarket);
    if (bfRunnerCount !== srRunnerCount) {
      this.isValidMarketPair = false;
      if (showError) {
        this.appService.openErrorBar(
          `Runners count not equal. BetFair: ${bfRunnerCount}, SportRadar: ${srRunnerCount}`
        );
      }
      return false;
    }

    this.isValidMarketPair = true;
    return true;
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./runner-mapping-table.component.html",
  styleUrls: ["./market-mapping-table.component.scss"],
})
export class RunnerMappingModal {
  mappedEventsTableHeaders: string[] = ["runnerId", "runnerName"];
  mappedRunnersHeader: string[] = [
    "bfRunnerId",
    "bfRunnerName",
    "srRunnerId",
    "srRunnerName",
    "action",
  ];
  DATA;
  bfRunners = [];
  srRunners = [];
  mappedRunners = [];
  runnerObj = {
    bfRunnerId: "",
    srRunnerId: "",
    bfRunnerName: "",
    srRunnerName: "",
  };
  bfCompititionId;
  srCompetitionId;
  runners = [];
  maxBets: number | null = null;
  maxRisk: number | null = null;
  status = "BLOCKED";
  maxBetsPresets: number[] = [5, 10, 15, 20, 25, 30, 40, 50, 75, 100];
  maxRiskPresets: Array<{ label: string; value: number }> = [
    { label: "50k", value: 50000 },
    { label: "1 lakh", value: 100000 },
    { label: "1.5 lakh", value: 150000 },
    { label: "2 lakh", value: 200000 },
    { label: "2.5 lakh", value: 250000 },
    { label: "3 lakh", value: 300000 },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private appService: AppService,
    public dialogRef: MatDialogRef<RunnerMappingModal>
  ) {
    this.DATA = data;
  }

  ngOnInit() {
    this.bfRunners = (this.DATA.selectedBFMarket[0].Runners || []).map((runner) =>
      this.toRunnerShape(runner)
    );
    this.srRunners = (this.DATA.selectedSRMarket[0].Runners || []).map((runner) =>
      this.toRunnerShape(runner)
    );
    this.bfCompititionId = this.DATA.selectedBFMarket[0].CompetitionId;
    this.srCompetitionId = this.DATA.selectedSRMarket[0].CompetitionId;
    this.status = this.DATA && this.DATA.status === "ACTIVE" ? "ACTIVE" : "BLOCKED";
    if (this.DATA.mapped) {
      this.maxBets = this.DATA.maxBets || null;
      this.maxRisk = this.DATA.maxRisk || null;
      const preMapped = (this.DATA.preMappedRunners || []).map((runner) => ({
        bfRunnerId: runner && runner.bfRunnerId ? runner.bfRunnerId : "",
        bfRunnerName: runner && runner.bfRunnerName ? runner.bfRunnerName : "",
        srRunnerId: runner && runner.srRunnerId ? runner.srRunnerId : "",
        srRunnerName: runner && runner.srRunnerName ? runner.srRunnerName : "",
      }));
      this.mappedRunners = preMapped;
      if (preMapped.length) {
        const mappedBFIds = new Set(preMapped.map((runner) => String(runner.bfRunnerId)));
        const mappedSRIds = new Set(preMapped.map((runner) => String(runner.srRunnerId)));
        this.bfRunners = this.bfRunners.filter(
          (runner) => !mappedBFIds.has(String(runner.RunnerId))
        );
        this.srRunners = this.srRunners.filter(
          (runner) => !mappedSRIds.has(String(runner.RunnerId))
        );
      }
    } else {
      this.maxBets = this.DATA.maxBets || 20;
      this.maxRisk = this.DATA.maxRisk || 50000;
    }
    if (!this.DATA.mapped) {
      this.autoPairRunnersByClosestName();
    }
  }

  setStatus(status: any) {
    this.status = status;
  }

  setMaxBetsPreset(value: number) {
    this.maxBets = value;
  }

  isPresetSelected(value: number): boolean {
    return Number(this.maxBets) === value;
  }

  setMaxRiskPreset(value: number) {
    this.maxRisk = value;
  }

  isRiskPresetSelected(value: number): boolean {
    return Number(this.maxRisk) === value;
  }

  getBetfairMarketLabel(): string {
    const market = this.DATA && this.DATA.selectedBFMarket && this.DATA.selectedBFMarket[0]
      ? this.DATA.selectedBFMarket[0]
      : null;
    if (!market) {
      return "-";
    }
    const name = market.MarketName || "-";
    const id = market.MarketId !== undefined ? market.MarketId : "-";
    return `${name} (${id})`;
  }

  getSportRadarMarketLabel(): string {
    const market = this.DATA && this.DATA.selectedSRMarket && this.DATA.selectedSRMarket[0]
      ? this.DATA.selectedSRMarket[0]
      : null;
    if (!market) {
      return "-";
    }
    const name = market.MarketName || "-";
    const id = market.MarketId !== undefined ? market.MarketId : "-";
    return `${name} (${id})`;
  }

  getValue() {
    const hasEmpty = Object.keys(this.runnerObj).some((element) => {
      return this.runnerObj[element] === "";
    });
    return !hasEmpty;
  }

  sliceRunners() {
    if (this.getValue()) {
      // console.log("true");
      this.srRunners = this.srRunners.filter((runner) => {
        return runner.RunnerId !== this.runnerObj.srRunnerId;
      });

      this.bfRunners = this.bfRunners.filter((runner) => {
        return runner.RunnerId !== this.runnerObj.bfRunnerId;
      });

      this.mappedRunners = this.mappedRunners.concat([{ ...this.runnerObj }]);
      // console.log("mappedRunners", this.mappedRunners);
      Object.keys(this.runnerObj).forEach((element) => {
        this.runnerObj[element] = "";
      });
      // console.log(this.srRunners, this.bfRunners, this.runnerObj);
    } else {
      // console.log("false");
    }
  }

  deleteMappedRecord(ele) {
    this.mappedRunners = this.mappedRunners.filter((runner) => {
      return runner.bfRunnerId !== ele.bfRunnerId;
    });
    this.srRunners = this.srRunners.concat([
      { RunnerId: ele.srRunnerId, RunnerName: ele.srRunnerName },
    ]);
    this.bfRunners = this.bfRunners.concat([
      { RunnerId: ele.bfRunnerId, RunnerName: ele.bfRunnerName },
    ]);
  }

  selectRunner(ele, pid) {
    if (pid === "SportRadar") {
      this.runnerObj.srRunnerId = ele.RunnerId;
      this.runnerObj.srRunnerName = ele.RunnerName;
      this.sliceRunners();
      // console.log(this.bfRunners, this.srRunners);
    } else if (pid === "BetFair") {
      this.runnerObj.bfRunnerId = ele.RunnerId;
      this.runnerObj.bfRunnerName = ele.RunnerName;
      this.sliceRunners();
      // console.log(this.bfRunners, this.srRunners);
    }
  }

  private toRunnerShape(runner: any) {
    const runnerId =
      runner && (runner.RunnerId !== undefined ? runner.RunnerId : runner.runnerId);
    const runnerName =
      runner && (runner.RunnerName !== undefined ? runner.RunnerName : runner.runnerName);
    return {
      // Template expects camelCase, but prod payload can be PascalCase.
      runnerId: runnerId,
      runnerName: runnerName,
      RunnerId: runnerId,
      RunnerName: runnerName,
    };
  }

  private normalizeRunnerName(name: any): string {
    return String(name || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  private levenshteinDistance(a: string, b: string): number {
    const aLen = a.length;
    const bLen = b.length;
    if (!aLen) {
      return bLen;
    }
    if (!bLen) {
      return aLen;
    }
    const matrix: number[][] = Array.from({ length: aLen + 1 }, () => Array(bLen + 1).fill(0));
    for (let i = 0; i <= aLen; i++) {
      matrix[i][0] = i;
    }
    for (let j = 0; j <= bLen; j++) {
      matrix[0][j] = j;
    }
    for (let i = 1; i <= aLen; i++) {
      for (let j = 1; j <= bLen; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost
        );
      }
    }
    return matrix[aLen][bLen];
  }

  private getNameSimilarityScore(nameA: any, nameB: any): number {
    const a = this.normalizeRunnerName(nameA);
    const b = this.normalizeRunnerName(nameB);
    if (!a || !b) {
      return 0;
    }
    if (a === b) {
      return 1;
    }
    if (a.includes(b) || b.includes(a)) {
      return 0.92;
    }

    const aTokens = new Set(a.split(" ").filter(Boolean));
    const bTokens = new Set(b.split(" ").filter(Boolean));
    const intersectionCount = Array.from(aTokens).filter((token) => bTokens.has(token)).length;
    const unionTokens = Array.from(aTokens).concat(Array.from(bTokens));
    const unionCount = new Set(unionTokens).size || 1;
    const tokenScore = intersectionCount / unionCount;

    const maxLen = Math.max(a.length, b.length) || 1;
    const levScore = 1 - this.levenshteinDistance(a, b) / maxLen;

    return Math.max(tokenScore, levScore);
  }

  private autoPairRunnersByClosestName() {
    if (!this.bfRunners.length || !this.srRunners.length) {
      return;
    }

    const threshold = 0.45;
    const candidates: Array<{ bfIndex: number; srIndex: number; score: number }> = [];

    for (let i = 0; i < this.bfRunners.length; i++) {
      for (let j = 0; j < this.srRunners.length; j++) {
        const score = this.getNameSimilarityScore(
          this.bfRunners[i].RunnerName,
          this.srRunners[j].RunnerName
        );
        if (score >= threshold) {
          candidates.push({ bfIndex: i, srIndex: j, score });
        }
      }
    }

    candidates.sort((a, b) => b.score - a.score);

    const matchedBF = new Set<number>();
    const matchedSR = new Set<number>();
    const mapped: any[] = [];

    candidates.forEach((candidate) => {
      if (matchedBF.has(candidate.bfIndex) || matchedSR.has(candidate.srIndex)) {
        return;
      }
      const bfRunner = this.bfRunners[candidate.bfIndex];
      const srRunner = this.srRunners[candidate.srIndex];
      matchedBF.add(candidate.bfIndex);
      matchedSR.add(candidate.srIndex);
      mapped.push({
        bfRunnerId: bfRunner.RunnerId,
        bfRunnerName: bfRunner.RunnerName,
        srRunnerId: srRunner.RunnerId,
        srRunnerName: srRunner.RunnerName,
      });
    });

    if (!mapped.length) {
      return;
    }

    this.mappedRunners = this.mappedRunners.concat(mapped);
    this.bfRunners = this.bfRunners.filter((_, index) => !matchedBF.has(index));
    this.srRunners = this.srRunners.filter((_, index) => !matchedSR.has(index));
  }

  getMappedRunners() {
    let obj = {
      bRunnerId: "",
      sRunnerId: "",
      bRunnerName: "",
      sRunnerName: "",
    };
    let arrayOfRunners = [];
    this.mappedRunners.forEach((runner) => {
      obj.bRunnerId = runner.bfRunnerId;
      obj.sRunnerId = runner.srRunnerId;
      obj.bRunnerName = runner.bfRunnerName || "";
      obj.sRunnerName = runner.srRunnerName || "";
      arrayOfRunners.push({ ...obj });
    });
    return arrayOfRunners;
  }

  canSubmit(): boolean {
    const totalBfRunners = this.mappedRunners.length + this.bfRunners.length;
    const totalSrRunners = this.mappedRunners.length + this.srRunners.length;

    return (
      this.mappedRunners.length > 0 &&
      this.mappedRunners.length === totalBfRunners &&
      this.mappedRunners.length === totalSrRunners
    );
  }

  submit() {
    if (!this.canSubmit()) {
      this.appService.openErrorBar("Please map all runners before submitting.");
      return;
    }

    const payload = {
      bSportId: this.DATA.bfsportId,
      sSportId: this.DATA.srsportId,
      bEventId: this.DATA.bfeventId,
      sEventId: this.DATA.sreventId,
      sCompetitionId: this.srCompetitionId,
      bCompetitionId: this.bfCompititionId,
      bMarketId: this.DATA.bfmarketId,
      sMarketId: this.DATA.srmarketId,
      bMarketName:
        this.DATA &&
        this.DATA.selectedBFMarket &&
        this.DATA.selectedBFMarket[0] &&
        this.DATA.selectedBFMarket[0].MarketName
          ? this.DATA.selectedBFMarket[0].MarketName
          : "",
      sMarketName:
        this.DATA &&
        this.DATA.selectedSRMarket &&
        this.DATA.selectedSRMarket[0] &&
        this.DATA.selectedSRMarket[0].MarketName
          ? this.DATA.selectedSRMarket[0].MarketName
          : "",
      b2sRunners: this.getMappedRunners(),
      maxBets: this.maxBets,
      maxRisk: this.maxRisk,
      status: this.status,
    };

    const request$ = this.DATA.mapped
      ? this.appService.editB2sMappedMarket(payload)
      : this.appService.addMarketMapping(payload);

    request$.subscribe(
      (res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(
            this.DATA.mapped ? "Runner mapping updated" : "Runner mapping added"
          );
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      },
      () => {
        this.appService.openErrorBar("Failed to save runner mapping");
      }
    );
  }
}
